import React from 'react'

import { Layout, SectionTitle, ItemTitle, Header } from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        title={data.title}
        site={data.site}
        state="develop"
        slug={data.slug + '/develop/'}
      />
      <Layout
        category={data.category}
        changelog={changelog[data.title].changelog}
        description={data.description}
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        updated={changelog[data.title].lastUpdated}
      >
        <SectionTitle> Classes</SectionTitle>
        <p>
          Margins can be placed at any side of an element, top, bottom, left or
          right. Use our predefined margin classes to quickly add consistent
          spacing between elements in the interface.
        </p>
        <ItemTitle>Top Margin</ItemTitle>
        <table class="table">
          <thead>
            <th>Class</th>
            <th>Value (px)</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="table__code">.l-margin-top--none</span>
              </td>
              <td>0</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-top--xxxsmall</span>
              </td>
              <td>2</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-top--xxsmall</span>
              </td>
              <td>4</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-top--xsmall</span>
              </td>
              <td>8</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-top--small</span>
              </td>
              <td>12</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-top--medium</span>
              </td>
              <td>16</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-top--large</span>
              </td>
              <td>24</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-top--xlarge</span>
              </td>
              <td>32</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-top--xxlarge</span>
              </td>
              <td>48</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-top--xxxlarge</span>
              </td>
              <td>64</td>
            </tr>
          </tbody>
        </table>
        <ItemTitle>Bottom Margin</ItemTitle>
        <table class="table">
          <thead>
            <th>Class</th>
            <th>Value (px)</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="table__code">.l-margin-bottom--none</span>
              </td>
              <td>0</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-bottom--xxxsmall</span>
              </td>
              <td>2</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-bottom--xxsmall</span>
              </td>
              <td>4</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-bottom--xsmall</span>
              </td>
              <td>8</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-bottom--small</span>
              </td>
              <td>12</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-bottom--medium</span>
              </td>
              <td>16</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-bottom--large</span>
              </td>
              <td>24</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-bottom--xlarge</span>
              </td>
              <td>32</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-bottom--xxlarge</span>
              </td>
              <td>48</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-bottom--xxxlarge</span>
              </td>
              <td>64</td>
            </tr>
          </tbody>
        </table>
        <ItemTitle>Left Margin</ItemTitle>
        <table class="table">
          <thead>
            <th>Class</th>
            <th>Value (px)</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="table__code">.l-margin-left--none</span>
              </td>
              <td>0</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-left--xxxsmall</span>
              </td>
              <td>2</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-left--xxsmall</span>
              </td>
              <td>4</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-left--xsmall</span>
              </td>
              <td>8</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-left--small</span>
              </td>
              <td>12</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-left--medium</span>
              </td>
              <td>16</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-left--large</span>
              </td>
              <td>24</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-left--xlarge</span>
              </td>
              <td>32</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-left--xxlarge</span>
              </td>
              <td>48</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-left--xxxlarge</span>
              </td>
              <td>64</td>
            </tr>
          </tbody>
        </table>
        <ItemTitle>Right Margin</ItemTitle>
        <table class="table">
          <thead>
            <th>Class</th>
            <th>Value (px)</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="table__code">.l-margin-right--none</span>
              </td>
              <td>0</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-right--xxxsmall</span>
              </td>
              <td>2</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-right--xxsmall</span>
              </td>
              <td>4</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-right--xsmall</span>
              </td>
              <td>8</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-right--small</span>
              </td>
              <td>12</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-right--medium</span>
              </td>
              <td>16</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-right--large</span>
              </td>
              <td>24</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-right--xlarge</span>
              </td>
              <td>32</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-right--xxlarge</span>
              </td>
              <td>48</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-right--xxxlarge</span>
              </td>
              <td>64</td>
            </tr>
          </tbody>
        </table>
        <ItemTitle>Vertical Margin</ItemTitle>
        <table class="table">
          <thead>
            <th>Class</th>
            <th>Value (px)</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="table__code">.l-margin-vertical--none</span>
              </td>
              <td>0</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-vertical--xxxsmall</span>
              </td>
              <td>2</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-vertical--xxsmall</span>
              </td>
              <td>4</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-vertical--xsmall</span>
              </td>
              <td>8</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-vertical--small</span>
              </td>
              <td>12</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-vertical--medium</span>
              </td>
              <td>16</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-vertical--large</span>
              </td>
              <td>24</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-vertical--xlarge</span>
              </td>
              <td>32</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-vertical--xxlarge</span>
              </td>
              <td>48</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-vertical--xxxlarge</span>
              </td>
              <td>64</td>
            </tr>
          </tbody>
        </table>
        <ItemTitle>Horizontal Margin</ItemTitle>
        <table class="table">
          <thead>
            <th>Class</th>
            <th>Value (px)</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="table__code">.l-margin-horizontal--none</span>
              </td>
              <td>0</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-horizontal--xxxsmall</span>
              </td>
              <td>2</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-horizontal--xxsmall</span>
              </td>
              <td>4</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-horizontal--xsmall</span>
              </td>
              <td>8</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-horizontal--small</span>
              </td>
              <td>12</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-horizontal--medium</span>
              </td>
              <td>16</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-horizontal--large</span>
              </td>
              <td>24</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-horizontal--xlarge</span>
              </td>
              <td>32</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-horizontal--xxlarge</span>
              </td>
              <td>48</td>
            </tr>
            <tr>
              <td>
                <span class="table__code">.l-margin-horizontal--xxxlarge</span>
              </td>
              <td>64</td>
            </tr>
          </tbody>
        </table>
      </Layout>
    </>
  )
}

export const code = {
  top: `<div class="l-margin-top--xxsmall"></div>
`,
  bottom: `<div class="l-margin-bottom--xxsmall"></div>
`,
  left: `<div class="l-margin-left--xxsmall"></div>
`,
  right: `<div class="l-margin-right--xxsmall"></div>
`,
}
